var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOp2MiseLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 30,
    viewBox: "0 0 25 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7917 22.6493C11.6277 22.6493 11.468 22.5862 11.3461 22.4643C11.1022 22.2163 11.1022 21.8169 11.3503 21.5731C12.0313 20.9005 12.7123 20.2405 13.3849 19.5889C18.1688 14.9689 22.297 10.9837 20.3338 6.16617C17.3281 -0.900414 4.9647 2.4374 4.83858 2.47524C4.50228 2.56772 4.15336 2.37014 4.06088 2.03804C3.96839 1.70174 4.16597 1.35703 4.49807 1.26034C5.04877 1.1048 18.0553 -2.40538 21.494 5.68274C23.7851 11.299 19.1567 15.7677 14.2593 20.4969C13.5909 21.1401 12.9141 21.7959 12.2373 22.4685C12.1112 22.5862 11.9514 22.6493 11.7917 22.6493Z",
    fill: "url(#paint0_linear_3365_8620)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.40078 22.8091C3.25785 22.8091 3.11072 22.7587 2.99301 22.662C2.72817 22.435 2.69454 22.0398 2.91734 21.775C5.03606 19.2737 7.22204 17.0709 9.14738 15.1246C11.388 12.8629 14.1751 10.0548 13.9061 9.28969C13.1914 8.05378 8.89094 8.60027 6.04497 9.38638C5.70867 9.47887 5.35975 9.28129 5.26727 8.94498C5.17479 8.60868 5.37236 8.26397 5.70446 8.16728C7.02025 7.80155 13.6454 6.12003 15.0285 8.71798L15.0495 8.76001C15.7179 10.2818 13.5824 12.4383 10.0428 16.0074C8.13005 17.9369 5.9651 20.1187 3.88002 22.5821C3.75811 22.7334 3.58155 22.8091 3.40078 22.8091Z",
    fill: "url(#paint1_linear_3365_8620)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8339 29.6696H1.02559C0.676674 29.6696 0.39502 29.3879 0.39502 29.039C0.39502 28.6901 0.676674 28.4084 1.02559 28.4084H20.8339C21.1828 28.4084 21.4645 28.6901 21.4645 29.039C21.4645 29.3879 21.1786 29.6696 20.8339 29.6696Z",
    fill: "url(#paint2_linear_3365_8620)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9586 19.0592C8.8488 20.1606 7.69696 21.2998 6.59136 22.4559C6.46945 22.5862 6.3013 22.6492 6.13735 22.6492C5.98181 22.6492 5.82207 22.5904 5.70016 22.4727C5.44793 22.2331 5.43952 21.8337 5.67914 21.5815C6.79735 20.417 7.94919 19.2694 9.0674 18.1638C13.3216 13.9432 17.3405 9.95377 15.9028 8.02002C13.8219 4.80832 5.9692 7.112 2.84998 8.36473C2.8668 8.28065 2.8794 8.18817 2.8794 8.09989C2.8794 7.72575 2.71546 7.39786 2.45902 7.16665C4.3129 6.43939 14.0741 2.87877 16.9369 7.30117C19.0094 10.0799 14.814 14.2374 9.9586 19.0592ZM2.46322 7.16244C2.24042 6.96066 1.94616 6.83455 1.62247 6.83455C0.924637 6.83455 0.361328 7.39786 0.361328 8.09569C0.361328 8.79352 0.924637 9.35683 1.62247 9.35683C2.22782 9.35683 2.73227 8.93224 2.85418 8.36053C2.871 8.27645 2.88361 8.18397 2.88361 8.09569C2.88361 7.72155 2.71966 7.39365 2.46322 7.16244Z",
    fill: "url(#paint3_linear_3365_8620)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.32413 22.334L9.1686 22.4811C9.04669 22.5946 8.89114 22.6493 8.73981 22.6493C8.57165 22.6493 8.4035 22.582 8.27739 22.4475C8.04197 22.1911 8.05459 21.7917 8.31102 21.5563L8.46656 21.4091C14.4149 15.8854 20.0354 10.6642 18.0933 6.87661C15.5878 2.41638 6.67574 4.61076 4.58645 5.19929C4.63269 5.06477 4.66212 4.92605 4.66212 4.77891C4.66212 4.46363 4.54021 4.17777 4.34684 3.95497C6.83128 3.25714 16.2436 1.01651 19.2031 6.27967C21.5908 10.9417 15.634 16.4739 9.32413 22.334ZM4.35104 3.95497C4.11983 3.69013 3.78353 3.51777 3.40518 3.51777C2.70735 3.51777 2.14404 4.08108 2.14404 4.77891C2.14404 5.47674 2.70735 6.04005 3.40518 6.04005C3.95168 6.04005 4.4141 5.68693 4.59066 5.19929C4.6369 5.06477 4.66632 4.92605 4.66632 4.77891C4.66212 4.46363 4.54441 4.17777 4.35104 3.95497Z",
    fill: "url(#paint4_linear_3365_8620)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4776 26.6513C22.4776 26.8825 22.5449 27.0969 22.6542 27.2818H2.61885C2.26994 27.2818 1.98828 27.0002 1.98828 26.6513C1.98828 26.3024 2.26994 26.0207 2.61885 26.0207H22.6542C22.5449 26.2057 22.4776 26.4201 22.4776 26.6513ZM23.7387 25.3901C23.2721 25.3901 22.8728 25.6466 22.6542 26.0207C22.5449 26.2057 22.4776 26.4201 22.4776 26.6513C22.4776 26.8825 22.5449 27.0969 22.6542 27.2818C22.8728 27.656 23.2763 27.9124 23.7387 27.9124C24.4366 27.9124 24.9999 27.3491 24.9999 26.6513C24.9999 25.9534 24.4366 25.3901 23.7387 25.3901Z",
    fill: "url(#paint5_linear_3365_8620)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5729 24.3266C19.5729 24.5578 19.6402 24.7722 19.7495 24.9571H0.63057C0.281655 24.9571 0 24.6755 0 24.3266C0 23.9777 0.281655 23.696 0.63057 23.696H19.7495C19.636 23.8852 19.5729 24.0954 19.5729 24.3266ZM20.834 23.0654C20.3674 23.0654 19.9681 23.3219 19.7495 23.696C19.6402 23.881 19.5729 24.0954 19.5729 24.3266C19.5729 24.5578 19.6402 24.7722 19.7495 24.9571C19.9681 25.3313 20.3716 25.5877 20.834 25.5877C21.5319 25.5877 22.0952 25.0244 22.0952 24.3266C22.0952 23.6329 21.5277 23.0654 20.834 23.0654Z",
    fill: "url(#paint6_linear_3365_8620)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3365_8620",
    x1: 13.0642,
    y1: 22.6483,
    x2: 13.0642,
    y2: 0.369133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#177269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BDCCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3365_8620",
    x1: 8.97472,
    y1: 22.8077,
    x2: 8.97472,
    y2: 7.29596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#177269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BDCCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3365_8620",
    x1: 0.39296,
    y1: 29.0402,
    x2: 21.4627,
    y2: 29.0402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1BDCCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#177269"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3365_8620",
    x1: 8.92048,
    y1: 22.6483,
    x2: 8.92048,
    y2: 5.11872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#177269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BDCCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3365_8620",
    x1: 10.9423,
    y1: 22.6483,
    x2: 10.9423,
    y2: 2.88317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#177269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BDCCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3365_8620",
    x1: 1.98584,
    y1: 26.6507,
    x2: 26.3359,
    y2: 26.6507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1BDCCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#177269"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3365_8620",
    x1: -0.00533883,
    y1: 24.3276,
    x2: 24.0142,
    y2: 24.3276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1BDCCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#177269"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOp2MiseLogoSmall);
export default __webpack_public_path__ + "static/media/op2miseLogoSmall.1b6a35c199b7a908340429ceb155e7b4.svg";
export { ForwardRef as ReactComponent };